export const DUMMY_DATA = [
    { key: 'ASSET', name: 'Asset', value: 50 },
    { key: 'PEOPLE', name: 'People', value: 20 },
    { key: 'SENSOR', name: 'Sensor', value: 30 },
];

export const INIT_DATA = [];

export const INIT_CATEGORY_STATUS = {};
